// extracted by mini-css-extract-plugin
export default {"headerTabs":"qHKhWH4onmC7SQggORRw","tableRow":"JmeLAV87kPzaTltjAhCD","active":"lPpKQ_OEs1A0mF3nRESD","status":"a8LBy7I4fQYJtQkRpt71"};